
import ReceiverChannelMobileCard from "./receiver-channel-mobile-card.vue";
import { mapGetters } from "vuex";
import { ALL_CHANNELS } from "@/constants/Channels.js";

export default {
  components: {
    ReceiverChannelMobileCard
  },
  data() {
    return {
      channel: "",
      ALL_CHANNELS
    };
  },
  computed: {
    ...mapGetters("restaurant", ["getLocationChannels"])
  }
};
